// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Xlat","left":"styles_left__CvylD"};